<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(v-if="!isSFS" vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:disabled="hasBranch()" :placeholder='$t("branches.branch_placeholder")' :danger="$v.form.branch_id.$invalid && $v.form.branch_id.$model" :danger-text="$t('validation.required', { attribute: $t('branches.branch') })" v-model="form.branch_id" :label='$t("branches.branch")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in branches")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group.separator
          vm-input(:placeholder='$t("purchase_orders.manual_folio_placeholder")' :label='$t("purchase_orders.manual_folio")' :danger="$v.form.manual_folio.$invalid && $v.form.manual_folio.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.manual_folio') })" v-model="form.manual_folio")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group.separator
          vm-select(:placeholder='$t("purchase_orders.supplier_placeholder")' :danger="$v.form.supplier_id.$invalid && $v.form.supplier_id.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.supplier_display') })" v-model="form.supplier_id" :label='$t("purchase_orders.supplier_display")')
            vm-select-item(:key='index', :value='item.id', :text='item.business_name', v-for='item,index in suppliers')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group.separator
          label.vm-input--label {{ $t('purchase_orders.currency_display') }}
          .radio-section
            .radio-item(v-for='(currency, index) in currencies' :key="index")
              input.radio-margin(type="radio" :value="currency.id" :id="currency.id" v-model="form.currency_id")
              label.radio-label(:for="currency.id") {{ currency.code }}
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group.separator
          vm-input(v-if="form.currency_id === 1" :placeholder='$t("purchase_orders.exchange_rate_placeholder")' :label='$t("purchase_orders.exchange_rate")' :danger="$v.form.exchange_rate.$invalid && $v.form.exchange_rate.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.exchange_rate') })" v-model="form.exchange_rate")
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')

export default {
  name: 'ModalPurchaseOrders',
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        branch_id: {
          required: requiredIf(function () {
            return !this.isSFS
          })
        },
        manual_folio: {
          required
        },
        supplier_id: {
          required
        },
        currency_id: {
          required
        },
        exchange_rate: {
          required: requiredIf(function () {
            return this.form.currency_id === 1
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'currencies', 'branches', 'suppliers']),
    ...configMapGetters(['isSFS'])
  },
  watch: {
    isModalVisible (value) {
      if (value) {
        if (this.suppliers.length === 0) this.getSuppliers()
        if (this.currencies.length === 0) this.getCurrencies()
        if (!this.isSFS) {
          if (this.branches.length === 0) this.getBranches()
          if (this.hasBranch()) this.addBranch()
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'getCurrencies',
      'getBranches',
      'getSuppliers'
    ])
  }
}
</script>
